/**
 * Make `/#grupe` land on the section (23.09.2026).
 *
 * The page scrolled itself to the top on every navigation, which undid the
 * browser's own jump to the anchor — so a link to a section opened the top of
 * the homepage instead. This scrolls to the element when the URL names one,
 * and retries briefly: the sections below load their data (groups, webinars)
 * after the first paint, and their position moves while they do.
 */
const RETRIES = [0, 250, 700, 1400];

export function idFromHash(hash) {
  if (!hash || hash === "#") return "";
  try {
    return decodeURIComponent(hash.replace(/^#/, "")).trim();
  } catch {
    return hash.replace(/^#/, "").trim();
  }
}

export function scrollToHash(hash, {
  win = typeof window !== "undefined" ? window : undefined,
  doc = typeof document !== "undefined" ? document : undefined,
  schedule = (fn, ms) => setTimeout(fn, ms),
} = {}) {
  if (!win || !doc) return false;
  const id = idFromHash(hash);
  if (!id) {
    win.scrollTo(0, 0);
    return false;
  }
  const smooth = !win.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
  let found = false;
  RETRIES.forEach((ms) => schedule(() => {
    const el = doc.getElementById(id);
    if (!el) return;
    found = true;
    el.scrollIntoView({ behavior: smooth ? "smooth" : "auto", block: "start" });
  }, ms));
  return found;
}
